<div>
  <div id="check-route" [routerLink]="['/login']" routerLinkActive="out"></div>
  <nav class="header out navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand" href="#">Catalog Manager</span>
  </nav>
  <nav class="header in navbar navbar-expand-lg navbar-light bg-light">
    <button mat-button mat-icon-button class="sidenav-toggle" (click)="this.globals.menuToggle()">
      <mat-icon>menu</mat-icon>
    </button>
    
    <span class="navbar-brand" href="#">Catalog Manager</span>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <div class="navbar-nav mr-auto"></div>
      <!-- <form class="form-inline my-2 my-lg-0">
        <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
        <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
      </form> -->
      <button mat-button mat-icon-button>
        <mat-icon>help_outline</mat-icon>
      </button>
      <button mat-button mat-icon-button [matMenuTriggerFor]="menu" title="Admin">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #menu>
        <span class="account-name">Admin</span>
        <button mat-menu-item (click)="openShop()">
          <mat-icon>store</mat-icon>
          <span>Launch UNO Shop</span>
        </button>
        <button mat-menu-item (click)="signOut()">
          <mat-icon>power_settings_new</mat-icon>
          <span>Sign Out</span>
        </button>
      </mat-menu>
    </div>
  </nav>
</div>